import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { OneOffIncomePaymentModel } from "../../../../../Wrap/Models/Models/Processes/Drawdown/OneOffIncomePaymentModel";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { IStepConfig, StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { IncomePaymentOneOffAction } from "./Actions/IncomePaymentOneOffAction";
import { IncomePaymentOneOffDetail } from "./Components/IncomePaymentOneOffDetail";
import { IncomePaymentOneOffReview } from "./Components/IncomePaymentOneOffReview";
import { incomePaymentOneOffSteppersMap, NewIncomePaymentContent } from "./Resource/Content";
import { IncomePaymentOneOffStore } from "./Store/Variable";
interface INewIncomePaymentOneOffWizardState extends IAccountContextWizardComponentState {}
export class NewIncomePaymentOneOffWizard extends AccountContextWizardComponent<INewIncomePaymentOneOffWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(IncomePaymentOneOffStore, () => this.onInstructionStoreChange());
    }

    private onInstructionStoreChange() {
        if (IncomePaymentOneOffStore.getActionType() == ActionType.Success) {
            const data = IncomePaymentOneOffStore.getData();
            this.setState({
                isLoading: false,
                data: data,
            });
        }
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentDidUpdate() {
        const { customer, clientAccount, data } = this.state;
        if (customer && clientAccount && !data) {
            const id = getQueryParameters()["id"];
            const params = getQueryParameters();
            const subAccountHierarchyId = params["subaccounthierarchyid"];
            IncomePaymentOneOffAction.getInstruction(id, subAccountHierarchyId, customer.CustomerId);
        }
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (from == stepLength - 1) {return this.onExit();}
        const instructionId = this.getInstructionId();
        const instruction = this.state.data?.Instruction;
        if (!params["id"]) {params["id"] = instructionId;}

        IncomePaymentOneOffAction.saveInstruction(instructionId, instruction, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        // const id = this.getInstructionId();
        // IncomePaymentOneOffAction.deleteInstruction(id, () => this.onExit());
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        Navigator.navigateTo(Urls.get().main.Dashboard, {
            queryParamsObject: {
                hierarchyid: params["hierarchyid"],
            },
            scrollAfterNavigating: true,
        });
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        const id = this.getInstructionId();
        IncomePaymentOneOffAction.submitInstruction(id, this.state.data.Instruction, () =>
            this.setState({ isSubmitting: false })
        );
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        if (index == 0 && !stepProps.isReview) {
            stepProps.isReview = RestrictionStore.WithdrawDisabled();
        }
        return stepProps;
    }

    private getInstructionId(): number {
        const params = getQueryParameters();
        return params["id"] ?? this.state.data?.Instruction?.DrawdownSinglePaymentInstruction?.Id;
    }

    private setReviewConfirmSteppers() {
        return [];
    }

    setStepperConfig() {
        const steppers: IStepConfig[] = [
            {
                title: incomePaymentOneOffSteppersMap.incomePaymentOneOffDetail,
                url: Urls.get().IncomePaymentOneOffDetail,
                path: Contents.URLMap.incomePaymentOneOffDetail,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <IncomePaymentOneOffDetail {...this.getStepProps(0)} />,
            },
        ];

        steppers.push({
            title: incomePaymentOneOffSteppersMap.incomePaymentOneOffReview,
            url: Urls.get().IncomePaymentOneOffReview,
            path: Contents.URLMap.incomePaymentOneOffReview,
            onStepLeave: (from, to) => {
                this.onStepperLeave(from, to);
            },
            onSubmit: () => this.onSubmit(),
            canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
            component: <IncomePaymentOneOffReview {...this.getStepProps(1)} />,
        });

        const params = getQueryParameters();
        const data: OneOffIncomePaymentModel = this.state.data;

        steppers.push({
            title: incomePaymentOneOffSteppersMap.incomePaymentOneOffConfirmation,
            url: Urls.get().IncomePaymentOneOffConfirmation,
            path: Contents.URLMap.incomePaymentOneOffConfirmation,
            onStepLeave: (from, to) => {
                this.onStepperLeave(from, to);
            },
            type: StepType.Confirmation,
            component: (
                <Confirmation
                    onExit={
                        () => {}
                        //TODO: navigate to customer dashboard
                        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
                        //     queryParamsObject: {
                        //         hierarchyid: params["hierarchyid"],
                        //     },
                        //     scrollAfterNavigating: true,
                        // });
                    }
                    successMessage={NewIncomePaymentContent.successMessage(
                        data.ClientDetails.FirstName,
                        data.ClientDetails.LastName,
                        data.SubClAccountId
                    )}
                    isLoading={false}
                />
            ),
        });

        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "One-off income payment";
        return processProps;
    }
}
